module.exports = __webpack_public_path__ + "img/count_down.e37123aa.png";